import { create } from 'zustand';

interface DebugState {
  isGridVisible: boolean;
  toggleGrid: () => void;
  debug: boolean;
  toggleDebug: () => void;
}

export const useDebugStore = create<DebugState>((set) => ({
  isGridVisible: false,
  toggleGrid: () => {
    set((state: { isGridVisible: boolean }) => ({
      isGridVisible: !state.isGridVisible,
    }));
  },
  debug: false,
  toggleDebug: () =>
    set((state: { debug: boolean }) => ({ debug: !state.debug })),
}));
